(() => {
  const removableParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'fbclid',
    'msclkid',
    'yclid',
    'q',
  ];

  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || !href.includes('?')) return;

    try {
      const url = new URL(href, window.location.origin);

      removableParameters.forEach((parameter) => url.searchParams.delete(parameter));

      if (url.searchParams.get('page') === '1') {
        url.searchParams.delete('page');
      }

      link.setAttribute('href', url.toString().replace(/\?$/, ''));
    } catch {
      // Leave malformed third-party hreflang URLs untouched.
    }
  });
})();
